import styled from 'styled-components';
import Scrollbars from "react-custom-scrollbars-2";
import {FilterIcon, FilterInvertIcon, RoundPlusIcon, SquareMinusIcon} from "assets/images";

export const TickersSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #FFFFFF;
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 444px;
  gap: 10px;
  background: #D3E1D3;
  border-bottom: 1px solid rgba(98, 147, 97, 0.15);
`;

export const ButtonsWrapper = styled.div`
  padding: 20px 15px;
`

export const ButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 15px;
  height: 100%;
  width: 100%;
`;

export const TopElementsDiv = styled.div`
  background-color: ${(props) => props.theme.bg.grey};
  padding: 15px;
  border-bottom: 1px solid rgba(98, 147, 97, 0.15);
`;

export const TickersTitle = styled.h4`
  margin: 0 0 15px;
  font-weight: 600;
`;

export const SelectDiv = styled(Scrollbars)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const TickerName = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content:center;
  align-items:center;
  position: relative;

  ::after {
      content: '';
      position: absolute;
      background: rgba(98, 147, 97, 0.15);
      width: 1px;
      height: 35px;
      left: -9px;
      top: -11px;
  }
`

export const CustomRoundPlusIcon = styled(RoundPlusIcon)`
  cursor: pointer;
`;

export const CustomSquareMinusIcon = styled(SquareMinusIcon)`
  cursor: pointer;
`;

export const CustomFilterIcon = styled(FilterIcon)`
  cursor: pointer;
`
export const CustomFilterInvertIcon = styled(FilterInvertIcon)`
  cursor: pointer;
`
export const TickerItemDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 35px;
  padding: 9px 20px;
  border-bottom: 1px solid rgba(98, 147, 97, 0.15);
`;








